let config = require(`root/env/${process.env.NODE_ENV}`);

const API_URL = config.API_URL || 'http://dev.thanhtratp.greenglobal.vn:9830';
const API_SSO_URL = config.API_SSO_URL || 'http://dev.thanhtratp.greenglobal.vn:9830';
const API_URL_SSO = config.API_URL_SSO || 'https://login.quangngai.gov.vn/oauth2/authorize';
const CLIENT_ID = config.CLIENT_ID || '9yE_BFWfsdSs9OttIu_CY42NJq8a';
const REDIRECT_URI = config.REDIRECT_URI || 'https://quanlythanhtra.quangngai.gov.vn/api/sso/oauth2/callback';
const TimeDelay = 1000;
const LimitFileSize = 50;
const LimitVideoFileSize = 50;
const LimitFileType = ['doc', 'docx', 'pdf', 'rar', 'zip', 'jpg', 'png'];
const LimitFileType2 = ['doc', 'docx', 'pdf', 'xls', 'xlsx', 'rar', 'zip', 'jpg', 'png'];
const LimitPhotoType = ['jpg', 'png'];
const LimitVideoType = ['flv', 'mp4'];
const DateFormat = 'DD/MM/YYYY';
const ThanhPhoDN_ID = 9;
const TRACKER_URL = config.TRACKER_URL || 'http://tracker.thanhtratp.greenglobal.vn:9836';
const ENV = config.ENV || 'development';
const FILE_ENV = config.FILE_ENV || 'development';
const FILE_LIVE_ENV = 'live';
const checkServerLive = FILE_LIVE_ENV === FILE_ENV;
const siteKey = config.RECAPTCHA_SITE_KEY ;

export {
  API_URL,
  API_SSO_URL,
  checkServerLive,
  TimeDelay,
  LimitFileSize,
  LimitFileType,
  LimitFileType2,
  LimitPhotoType,
  LimitVideoType,
  LimitVideoFileSize,
  DateFormat,
  ThanhPhoDN_ID,
  TRACKER_URL,
  ENV,
  FILE_LIVE_ENV,
  FILE_ENV,
  siteKey,
  API_URL_SSO,
  CLIENT_ID,
  REDIRECT_URI
};



// WEBPACK FOOTER //
// ./src/constants/config.js